import { RetraitPlainte } from "../../model/RetraitPlainte";

export const initialState: RetraitPlainte = {
    codeRetrait: "",
    personneAddressantPlainte: "",
    contact: {
      nom: "",
      prenom: "",
      titre: "",
      courriel: "",
      telephone: ""
    },
    motifsRetrait: "",
    attestationRetraitVolontaire: false,
    attestationVeraciteInformations: false
  };